module.exports = __webpack_public_path__ + "static/media/MembersIcon.500840ce.svg";